















































import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'

import MatchListItem from '@/components/MatchListItem.vue'

import { Match } from '@/types/match'

@Component({
  components: {
    MatchListItem,
  },
})
export default class MatchListComponent extends Vue {
  @Prop() readonly matches!: Match[]
  @Prop({ type: String, default: 'No matches found...' }) readonly noResultsText!: string

  shouldClickCopyMatchApiLink = false

  search = ''

  filterSport: string[] = []

  /**
   * Filtered matches
   */
  get filteredMatches(): Match[] {
    let m = this.matches

    // Sport-filter is active
    if (this.filterSport.length) {
      m = m.filter((m) => this.filterSport.includes(m.sport))
    }

    if (this.search.length) {
      const s = this.search.toLowerCase()
      m = m.filter((m) => {
        if (m.hName.toLocaleLowerCase().includes(s)) {
          return true
        }
        if (m.vName.toLocaleLowerCase().includes(s)) {
          return true
        }

        return false
      })
    }

    return m
  }

  /**
   * Filtered matches with headers
   */
  get filteredMatchesWithHeaders(): Array<Match | { header: string }> {
    const matchDaysDict = _.groupBy(this.filteredMatches, (m) => {
      const d = m.kickoff.toDate()

      return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
    })

    return Object.values(matchDaysDict).reduce((items, matchDayGroup) => {
      // Concat multiple parts:
      return [
        // previous array of items with
        ...items,
        // header for next match day, and
        { header: String(matchDayGroup[0].kickoff.toDate().toLocaleDateString('sv-SE')) },
        // finally an array of the actual matches of the day
        ...matchDayGroup,
      ]
    }, [] as (Match | { header: string })[])
  }

  /**
   * Sports from matches
   */
  get sports(): { text: string; value: string }[] {
    const arr = this.matches.reduce((sports: string[], match: Match) => {
      if (!sports.includes(match.sport)) {
        sports.push(match.sport)
      }

      return sports
    }, [])

    const sports = arr.map((sport) => ({
      text: _.upperFirst(sport),
      value: sport,
    }))

    return sports
  }
}
